module.exports = __webpack_public_path__ + "img/mass-about-inactive@3x.png";